import React from 'react';
import Tour from 'reactour';
import { MdHelp } from 'react-icons/md';

//Estilos base:
const accentColor = "rgb(54,115,182)";
const iconStyle = { width: 20, height: 20 };

class HelpButton extends React.Component {

    constructor() {
        super();

        this.state = {
            isTourOpen: false
        }
    }

    render() {
        return (
            <React.Fragment>
                <li className="nav-item">
                    <button className="nav-link btn-magnify button-on-navbar" title="Ayuda"
                        data-tut="reactour__downloadSourcesResume.helpButton"
                        style={{ backgroundColor: "transparent", border: "none" }}
                        onClick={() => { if (!this.state.isTourOpen) { this.setState({ isTourOpen: true }); } }}>
                        <MdHelp style={iconStyle} />
                        <p>
                            <span className="d-lg-none d-md-block" style={{ marginLeft: 5 }}>
                                Ayuda
                            </span>
                        </p>
                    </button>
                </li>

                <Tour
                    startAt={0}
                    rounded={5}
                    maskClassName=""
                    className="helper"
                    accentColor={accentColor}
                    isOpen={this.state.isTourOpen}
                    steps={this.props.tourContent}
                    onRequestClose={() => { if (this.state.isTourOpen) { this.setState({ isTourOpen: false }); } }} />

            </React.Fragment>
        );
    }

    componentDidMount() {
        let hasUserSeenTheInitialTour = JSON.parse(localStorage.getItem("hasUserSeenTheInitialTour"));

        if (!hasUserSeenTheInitialTour) {
            this.setState({ isTourOpen: true });
            localStorage.setItem("hasUserSeenTheInitialTour", JSON.stringify(true));
        }
    }
}

export default HelpButton;